export function checkIsUnknownOrInApp(user_agent: string) {
  return /(zigzag)/i.test(user_agent) || /(Amazon)/i.test(user_agent) || /(Amazon Cloudfront)/i.test(user_agent);
}
